const mock = () => ({
  data: {
    resultInformation: { actionResult: 'EmailSent' },
  },
});

export default mock;
